module.exports = __webpack_public_path__ + "img/control_icon1.4d585ce2.png";